// extracted by mini-css-extract-plugin
export var bio = "header-person-module--bio--605f7";
export var expertise = "header-person-module--expertise--1cffe";
export var header = "header-person-module--header--89e7d";
export var image = "header-person-module--image--017d8";
export var position = "header-person-module--position--c5776";